import { Play, SkipForward, SkipBack, Volume1, Pause } from 'react-feather';

export default {
  Play,
  Pause,
  SkipForward,
  SkipBack,
  Volume: Volume1
};



// WEBPACK FOOTER //
// ./src/components/WebPlayer/icons.js